import React, { useState } from "react";
import { Label } from "@progress/kendo-react-labels";
import { Tooltip } from "@progress/kendo-react-tooltip";

const TooltipFormPure = (props) => {
  const { tooltipTitle, tooltipDescription, positionTooltip } = props;

  const iconTooltipStyles = {
    color: "#4F690C",
    fontSize: "14px",
    marginLeft: "5px",
    cursor: "pointer",
  };

  const TooltipContentTemplate = (props) => {
    return (
      <a>
        <strong>{props.title}</strong>
        <p>{props.content}</p>
        <p>{props.subContent}</p>
        <p>{props.restContent}</p>
      </a>
    );
  };

  const [open, setOpen] = useState(false);
  const handleOnChangeTooltip = () => setOpen(!open);
  const hiddeTooltip = () => setOpen(false);

  return (
    <Tooltip
      // {...props}
      position={positionTooltip ? positionTooltip : "right"}
      anchorElement="target"
      content={(props) => {
        return (
          <TooltipContentTemplate
            title={open ? tooltipTitle : props.title}
            content={open ? tooltipDescription : ""}
          />
        );
      }}
    >
      <Label className="form-inputs-labels">
        {props.text}
        <i
          className="k-icon k-i-information"
          style={iconTooltipStyles}
          title={props.title}
          onClick={() => handleOnChangeTooltip()}
          onMouseOut={() => hiddeTooltip()}
        />
      </Label>
    </Tooltip>
  );
};

export { TooltipFormPure as default };
